import apiUtil from "@/util/apiUtil";
import {TicketDetails} from "../TicketModels";

const ticketApi = {
    async getTicketDetails(
        locationId: number,
        businessDate: string,
        ticketNumber: number
    ): Promise<TicketDetails> {
        const url = `/api/tickets/${locationId}/${businessDate}/${ticketNumber}`;
        return await apiUtil.fetchData<TicketDetails>(url);
    }
};

export default ticketApi;
